import tagTester from './_tagTester.js';

export default tagTester('Object');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/_hasObjectTag.js
// module id = null
// module chunks = 